const map = (value, minA, maxA, minB, maxB) => {
    let val = (1 - (value - minA) / (maxA - minA)) * minB + (value - minA) / (maxA - minA) * maxB;

    if (val < minB) return minB;
    if (val > maxB) return maxB;
    return val;
}

export { map }